import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';

import CardTitle from '../../../common/card/CardTitle';
import { useGetTrainingVersions } from '../Training.hooks';
import { Training } from '../Training.interface';
import { formatDate } from '../../../common/formatter';

export interface TrainingVersionCardProps {
  training: Training;
}

const TrainingVersionCard: React.FC<TrainingVersionCardProps> = ({
  training
}) => {
  const history = useHistory();
  const { trainingVersions, isLoading, get } = useGetTrainingVersions(
    training.id
  );
  useEffect(() => {
    get(); // refresh if training object is updated
  }, [get, training]);
  return (
    <Card>
      <CardTitle>
        <ScheduleIcon />
        Training Versions
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Version</TableCell>
              <TableCell>Published</TableCell>
              <TableCell>Employee</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {trainingVersions && trainingVersions.length > 0 ? (
              trainingVersions.map((trainingVersion, index) => (
                <TableRow
                  key={trainingVersion.id}
                  hover
                  onClick={() => {
                    const { id, trainingId } = trainingVersion;
                    history.push(
                      `/portal/training/${trainingId}/version/${id}?view-only=1`
                    );
                  }}
                >
                  <TableCell>{trainingVersion.version}</TableCell>
                  <TableCell>{formatDate(trainingVersion.created)}</TableCell>
                  <TableCell>
                    {trainingVersion.createdBy.firstName}{' '}
                    {trainingVersion.createdBy.lastName}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No approved training versions</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default TrainingVersionCard;
